var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTmsLocationInact(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 5.5,
    stroke: "#D1D5DB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7491 10.4718C18.0152 9.73744 17.0386 9.33301 15.9997 9.33301C14.9608 9.33301 13.9841 9.73744 13.2497 10.4718C11.7336 11.9879 11.7336 14.455 13.2541 15.9755L14.6402 17.331C15.0152 17.6977 15.5075 17.881 15.9997 17.881C16.4919 17.881 16.9841 17.6977 17.3591 17.331L18.7491 15.9711C19.4836 15.2367 19.8886 14.26 19.8886 13.2212C19.8886 12.1823 19.4836 11.2068 18.7491 10.4718ZM15.9997 14.8828C15.0791 14.8828 14.333 14.1367 14.333 13.2162C14.333 12.2957 15.0791 11.5496 15.9997 11.5496C16.9202 11.5496 17.6663 12.2957 17.6663 13.2162C17.6663 14.1367 16.9202 14.8828 15.9997 14.8828ZM22.6663 18.6448C22.6674 18.8415 22.5647 19.0237 22.3969 19.1243L16.9186 22.4114C16.6352 22.5813 16.3175 22.6663 16.0002 22.6663C15.683 22.6663 15.3647 22.5813 15.0819 22.4114L9.60246 19.1243C9.43413 19.0232 9.33191 18.8409 9.33302 18.6448C9.33413 18.4487 9.43857 18.2676 9.60802 18.1688L12.3052 16.5899C12.3608 16.651 12.418 16.7116 12.4769 16.7705L13.863 18.1254C14.4341 18.6843 15.1936 18.9926 15.9997 18.9926C16.8058 18.9926 17.5647 18.6843 18.1363 18.1254L19.5352 16.7571C19.5897 16.7027 19.643 16.6466 19.6947 16.5899L22.3913 18.1682C22.5608 18.2676 22.6652 18.4493 22.6663 18.6448Z",
    fill: "#D1D5DB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTmsLocationInact);
export default __webpack_public_path__ + "static/media/tmsLocationInact.5641f4660077274aea6418e19936ee97.svg";
export { ForwardRef as ReactComponent };